import { getContext } from "svelte"
import { type Writable, writable } from "svelte/store"

type GalleryContext = { selected: number; count: number }

export const getDefaultGalleryContext = () => writable({ selected: 0, count: 0 })
export const getGalleryContext = (id: string | undefined): Writable<GalleryContext> =>
  id ? getContext(id) : getDefaultGalleryContext()
